import { NavRouteType } from '../types';

export const isPartOfRouteGroup = ({ baseRoute, path }: { baseRoute: string; path: string }) => {
  const normalizedPath = path.replace(/\/+$/, '');
  const normalizedBaseRoute = baseRoute.replace(/\/+$/, '');

  if (!normalizedPath.startsWith(normalizedBaseRoute)) {
    return false;
  }

  const basePath = normalizedPath.substring(0, normalizedBaseRoute.length);

  return basePath === normalizedBaseRoute;
};

export const getActiveRouteMenuKey = ({
  subMenu,
  pathname,
  linkPattern,
  search = '',
}: {
  subMenu: NavRouteType[];
  pathname: string;
  linkPattern: string;
  search: string;
}) => {
  let path = pathname + search;
  // menu with no sub menu
  if (!subMenu.length && isPartOfRouteGroup({ baseRoute: linkPattern, path })) return true;

  const subMenuSorted = [...subMenu].sort((a, b) => b.link.length - a.link.length);

  const activeMenu: NavRouteType | undefined = subMenuSorted.find(
    ({ id, link, subLinkPattern }) => {
      const hasPatterns = subLinkPattern && subLinkPattern.length;
      const regexMatched = !!(hasPatterns && subLinkPattern.some(pattern => pattern.test(path)));

      // CALL AI routes should rely only on regex patterns
      if (id.startsWith('CALL_AI_')) {
        return regexMatched;
      }

      // For all other routes, keep the existing fallback
      return regexMatched || path.includes(link);
    }
  );

  return activeMenu ? activeMenu.id : '';
};
